export function type(obj) {
    const toString = Object.prototype.toString
    const map = {
        '[object Boolean]': 'boolean',
        '[object Number]': 'number',
        '[object String]': 'string',
        '[object Function]': 'function',
        '[object Array]': 'array',
        '[object Date]': 'date',
        '[object RegExp]': 'regExp',
        '[object Undefined]': 'undefined',
        '[object Null]': 'null',
        '[object Object]': 'object'
    }
    
    return map[toString.call(obj)]
}

var _toString = Object.prototype.toString

export function isPlainObject(obj) {
    return _toString.call(obj) === '[object Object]'
}

// deepCopy
function _deepCopy(data, options, __deepCopy__) {
    const t = type(data);
    let o,
        exclude = options.exclude || [],
        depth = options.depth >= 0 ? options.depth : -1;
    
    if (t === 'array') {
        o = [];
    } else if (t === 'object') {
        o = {};
    } else {
        return data;
    }
    
    // 层级+1
    __deepCopy__.depth++
    // 超出最大复制层级
    if (depth >= 0 && __deepCopy__.depth > depth) {
        return o;
    }
    
    if (t === 'array') {
        for (let i = 0; i < data.length; i++) {
            o.push(_deepCopy(data[i], options, __deepCopy__))
        }
    } else if (t === 'object') {
        for (let i in data) {
            // 字段排除
            if (exclude.indexOf(i) < 0) {
                o[i] = _deepCopy(data[i], options, __deepCopy__)
            }
        }
    }
    return o;
}

export function deepCopy(data, options = {}) {
    // 递归数据
    var __deepCopy__ = {
        depth: -1
    }
    
    return _deepCopy(data, options, __deepCopy__)
}

// 根据path设置value
export function getContextByPath(obj, path) {
    let tempObj = obj
    
    if (!path) {
        throw new Error('[warn]: please transfer a valid prop path to obj!')
    }
    
    path = path.replace(/\[(\w+)\]/g, '.$1')
    path = path.replace(/^\./, '')
    
    let keyArr = path.split('.'),
        target = keyArr.slice(-1)[0]
    
    for (let i = 0; i < keyArr.length - 1; ++i) {
        let key = keyArr[i]
        
        if (key in tempObj) {
            tempObj = tempObj[key]
        } else {
            throw new Error('[warn]: please transfer a valid prop path to obj!')
        }
    }
    
    return {
        o: tempObj,
        k: target,
        a: keyArr
    }
}

// 偏函数
export function partial(fn, ...params){
	return function(...args){
		return fn.apply(this, params.concat(args))
	}
}